import React from 'react'

interface MilestoneTrackerProps {
  [key: string]: any
}

export const MilestoneTracker: React.FC<MilestoneTrackerProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">MilestoneTracker Component - Coming Soon</p>
    </div>
  )
}
